!(function () {
  'use strict';

  class CartBar extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('product-info');
      this.form = this.section.querySelector('[data-product-form]');
      this.formWrapper =
        (theme.settings.productPageSticky && this.section.querySelector('[data-form-wrapper]')) || this.form;
      this.handleProductAddError = this.handleProductAddError.bind(this);
      this.boundToggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this);
      this.boundSetCartBarHeight = this.setCartBarHeight.bind(this);
      this.boundSchedulePriceSync = this.schedulePriceSync.bind(this);
      this.syncPriceTimer = null;
      this._priceUnsubs = null;
    }

    connectedCallback() {
      this.toggleCartBarOnScroll();
      this.addEventListener('click', this.handleClick.bind(this));
      document.addEventListener('theme:scroll', this.boundToggleCartBarOnScroll);
      document.addEventListener('theme:resize', this.boundSetCartBarHeight);
      document.addEventListener('theme:product:add-error', this.handleProductAddError);

      if (typeof subscribe === 'function' && window.theme && window.theme.PUB_SUB_EVENTS) {
        this._priceUnsubs = [
          subscribe(window.theme.PUB_SUB_EVENTS.variantChange, this.boundSchedulePriceSync),
          subscribe(window.theme.PUB_SUB_EVENTS.optionValueSelectionChange, this.boundSchedulePriceSync),
        ];
      }
      this.schedulePriceSync();
    }

    /**
     * Mirror main PDP price into cart bar (variant changes; extras handled in extra-product-options).
     */
    syncPriceFromMainProduct() {
      if (!this.section) return;

      const mainPrice = this.section.querySelector('.product__content .price.product__price');
      const cartSpan = this.querySelector('[data-product-price]');
      const cartStrike = this.querySelector('.product__price--strike');
      if (!mainPrice || !cartSpan) return;

      const onSale =
        mainPrice.classList.contains('price--on-sale') || mainPrice.classList.contains('product__price--sale');
      const saleItem = mainPrice.querySelector('.price__sale .price-item--sale');
      const regularItem = mainPrice.querySelector('.price__regular .price-item--regular');
      const compareInSale = mainPrice.querySelector('.price__sale s.price-item--regular');

      if (onSale && saleItem) {
        cartSpan.textContent = saleItem.textContent.trim();
        cartSpan.classList.add('product__price--sale');
        if (cartStrike && compareInSale) {
          cartStrike.textContent = compareInSale.textContent.trim();
        }
      } else if (regularItem) {
        cartSpan.textContent = regularItem.textContent.trim();
        cartSpan.classList.remove('product__price--sale');
        if (cartStrike) cartStrike.textContent = '';
      }
    }

    schedulePriceSync() {
      if (this.syncPriceTimer) clearTimeout(this.syncPriceTimer);
      this.syncPriceTimer = setTimeout(() => {
        this.syncPriceTimer = null;
        this.syncPriceFromMainProduct();
      }, 80);
    }

    handleClick(event) {
      const addToCart = event.target.closest('[data-cart-bar-add-to-cart]');
      if (addToCart) {
        event.preventDefault();
        addToCart.classList.add('is-loading');
        addToCart.setAttribute('disabled', 'disabled');
        this.form.querySelector('[data-add-to-cart]').dispatchEvent(new Event('click', { bubbles: true }));
        return;
      }

      if (event.target.closest('[data-cart-bar-scroll]')) {
        event.preventDefault();
        this.scrollToTop();
      }
    }

    handleProductAddError() {
      if (this.querySelector('[data-cart-bar-add-to-cart]')) {
        this.scrollToTop();
      }
    }

    scrollToTop() {
      const active = document.activeElement;
      if (active && this.contains(active)) {
        active.blur();
      }

      // Hide immediately (scroll + theme:scroll run async; :has(*:focus) would keep bar visible until blur)
      this.classList.remove('is-visible');
      this.setCartBarHeight();

      const variantSelects = this.section.querySelector('variant-selects');
      const targetEl = window.theme.isMobile() ? variantSelects || this.form : this.section;
      const elementTop = targetEl.getBoundingClientRect().top;
      window.theme.scrollTo(window.theme.isMobile() ? elementTop - 10 : elementTop);

      const syncVisibility = () => this.toggleCartBarOnScroll();

      if ('onscrollend' in document) {
        document.addEventListener('scrollend', syncVisibility, { once: true, passive: true });
      }
      window.setTimeout(syncVisibility, 700);
    }

    /**
     * Sticky bar only when the main product form has scrolled past the viewport (configure / duplicate ATC).
     * offsetTop + offsetHeight is relative to offsetParent and breaks after layout / scroll, so use viewport rect.
     */
    toggleCartBarOnScroll() {
      if (!this.formWrapper) return;

      const pastForm = this.formWrapper.getBoundingClientRect().bottom < 0;
      this.classList.toggle('is-visible', pastForm);
      this.setCartBarHeight();
    }

    setCartBarHeight() {
      const visible = this.classList.contains('is-visible');
      const h = visible ? this.offsetHeight : 0;
      document.documentElement.style.setProperty('--cart-bar-height', `${h}px`);
    }

    disconnectedCallback() {
      document.removeEventListener('theme:product:add-error', this.handleProductAddError);
      document.removeEventListener('theme:scroll', this.boundToggleCartBarOnScroll);
      document.removeEventListener('theme:resize', this.boundSetCartBarHeight);
      if (this._priceUnsubs) {
        this._priceUnsubs.forEach(function (unsub) {
          unsub();
        });
        this._priceUnsubs = null;
      }
      if (this.syncPriceTimer) clearTimeout(this.syncPriceTimer);
    }
  }

  if (!customElements.get('cart-bar')) {
    customElements.define('cart-bar', CartBar);
  }
})();
